/* ============================================================
   MAAT Cart Fix — shims para custom elements Dawn-era
   ------------------------------------------------------------
   A pagina /cart usa <quantity-input>, <cart-items> e
   <cart-remove-button> (markup Dawn-era do main-cart-items.liquid).
   Mas o tema atual e Horizon, que define <quantity-selector> (nome
   diferente). Resultado: botoes +/- e remover NAO funcionam.

   Esta solucao define os custom elements faltantes manualmente,
   fazendo as operacoes via fetch /cart/change.js da Shopify Ajax API.
   ============================================================ */
(function () {
  'use strict';

  // ---------- helpers ----------
  // i18n: textos de window.MAAT.strings (layout/theme.liquid); o portugues e a reserva.
  function maatT(chave, pt) {
    var s = window.MAAT && window.MAAT.strings;
    return (s && s[chave]) || pt;
  }

  function debounce(fn, delay) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, delay);
    };
  }

  // ----------------------------------------------------------------
  // Section Rendering API (padrao nativo do Shopify / cart.js).
  // IMPORTANTE: NAO usar `?section_id=main-cart-footer` isolado — os blocks
  // (subtotal, botao checkout) vem do templates/cart.json e NAO
  // renderizam em request isolado de section, voltam VAZIOS e apagam o
  // botao de checkout. A forma correta e mandar `sections` + `sections_url`
  // na propria chamada /cart/change.js, que renderiza no contexto do template
  // (com blocks) e troca apenas o `.js-contents` (subtotal + line items),
  // preservando o botao de checkout (que fica fora do .js-contents).
  // ----------------------------------------------------------------
  function getCartSectionsToRender() {
    var list = [];
    var itemsEl = document.getElementById('main-cart-items');
    if (itemsEl && itemsEl.dataset.id) {
      list.push({ id: 'main-cart-items', section: itemsEl.dataset.id, selector: '.js-contents' });
    }
    var footerEl = document.getElementById('main-cart-footer');
    if (footerEl && footerEl.dataset.id) {
      list.push({ id: 'main-cart-footer', section: footerEl.dataset.id, selector: '.js-contents' });
    }
    return list;
  }

  function getSectionInnerHTML(html, selector) {
    if (!html) return null;
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function updateCartBadge(cart) {
    document.dispatchEvent(new CustomEvent('cart:update', { detail: cart, bubbles: true }));
    var badge = document.querySelector('.maat-cart-badge');
    // A26: quantidade no nome acessivel do link do carrinho.
    var icon = document.querySelector('.maat-cart-icon');
    var n = cart.item_count || 0;
    if (icon) icon.setAttribute('aria-label', n === 0 ? maatT('cart_empty', 'Carrinho vazio') : (n === 1 ? maatT('cart_one', 'Carrinho, 1 item') : maatT('cart_many', 'Carrinho, {n} itens').replace('{n}', n)));
    if (badge) {
      badge.textContent = String(cart.item_count);
      badge.style.display = cart.item_count > 0 ? '' : 'none';
    }
  }

  // a11y (reteste R7): o innerHTML recria os botoes de quantidade e o foco
  // caia no body. Guarda qual botao (plus/minus) de qual linha estava focado
  // e devolve o foco ao equivalente depois do render.
  function focoAtualNaQty() {
    var el = document.activeElement;
    if (!el || !el.matches) return null;
    var remover = el.closest && el.closest('cart-remove-button');
    if (remover) return { nome: 'remover', linha: parseInt(remover.dataset.index, 10) || 1 };
    if (!el.matches('button[name="plus"], button[name="minus"]')) return null;
    var input = el.parentElement && el.parentElement.querySelector('input[type="number"], input[name="updates[]"]');
    return input ? { nome: el.name, linha: getLineIndex(input) } : null;
  }

  function restaurarFocoQty(foco) {
    if (!foco) return;
    if (foco.nome === 'remover') {
      // Item removido: o foco vai para o "Remover" da linha que ocupou o lugar
      // (ou da ultima); sem itens, para o conteudo principal.
      var removers = document.querySelectorAll('cart-remove-button');
      var r = removers.length ? removers[Math.min(foco.linha, removers.length) - 1] : null;
      var link = r && r.querySelector('a, button');
      if (link) { link.focus(); return; }
      // Carrinho vazio: foco no titulo "O carrinho esta vazio". Fica para o
      // proximo quadro porque a troca para o estado vazio (is-empty) esconde o
      // conteudo e o navegador derrubava o foco no <body> (reteste do Q.A.).
      // setTimeout e nao requestAnimationFrame: rAF nao roda em aba oculta.
      setTimeout(function () {
        var alvo = document.querySelector('.cart__empty-text') || document.getElementById('MainContent');
        if (alvo) { alvo.setAttribute('tabindex', '-1'); alvo.focus(); }
      }, 50);
      return;
    }
    var inputs = document.querySelectorAll('cart-items input[type="number"], cart-items input[name="updates[]"], .cart-items input[type="number"], .maat-cart input[type="number"]');
    var alvo = null;
    Array.prototype.forEach.call(inputs, function (inp) {
      if (!alvo && getLineIndex(inp) === foco.linha) alvo = inp;
    });
    if (!alvo && inputs.length) alvo = inputs[Math.min(foco.linha, inputs.length) - 1];
    var btn = alvo && alvo.parentElement.querySelector('button[name="' + foco.nome + '"]');
    if (btn) { btn.focus(); return; }
    var main = document.getElementById('MainContent');
    if (main) { main.setAttribute('tabindex', '-1'); main.focus(); }
  }

  function changeLineQuantity(lineIndex, qty) {
    var foco = focoAtualNaQty();
    var toRender = getCartSectionsToRender();
    var body = { line: lineIndex, quantity: qty };
    if (toRender.length) {
      body.sections = toRender.map(function (s) { return s.section; });
      body.sections_url = window.location.pathname;
    }
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.sections) {
          toRender.forEach(function (s) {
            var container = document.getElementById(s.id);
            if (!container) return;
            var target = container.querySelector(s.selector) || container;
            var html = getSectionInnerHTML(cart.sections[s.section], s.selector);
            if (html !== null) target.innerHTML = html;
          });
          updateCartBadge(cart);
          // Estado vazio do Dawn: o cart.js nativo liga is-empty no <cart-items>
          // e no #main-cart-footer; como aqui so o .js-contents e trocado, sem
          // isso o /cart ficava com "Total R$ 0,00" e o botao de checkout.
          var vazio = cart.item_count === 0;
          document.querySelectorAll('cart-items').forEach(function (el) { el.classList.toggle('is-empty', vazio); });
          var rodape = document.getElementById('main-cart-footer');
          if (rodape) rodape.classList.toggle('is-empty', vazio);
          rewireQuantityInputs();
          restaurarFocoQty(foco);
          // Upsell de volume (ADR-0024) vive fora do .js-contents: avisa pra ele recalcular.
          document.dispatchEvent(new CustomEvent('maat:cart-changed', { detail: cart }));
        } else {
          // Sem sections na resposta: recarrega a pagina pra refletir o estado real
          window.location.reload();
        }
        return cart;
      })
      .catch(function () { window.location.reload(); });
  }

  // ---------- handlers ----------
  function getLineIndex(qtyInput) {
    // O Horizon/Dawn cart-items renderiza um input por linha do cart.
    // O id e' "Quantity-1", "Quantity-2", etc — 1-based index correspondente
    // a' line do cart. Nao e' garantido que sempre seja "Quantity-N",
    // entao tambem aceitamos data-line / data-index attributes.
    if (qtyInput.dataset.line) return parseInt(qtyInput.dataset.line, 10);
    if (qtyInput.dataset.index) return parseInt(qtyInput.dataset.index, 10);
    var match = /(\d+)$/.exec(qtyInput.id || '');
    return match ? parseInt(match[1], 10) : 1;
  }

  function handlePlusMinusClick(e) {
    var btn = e.target.closest('button[name="plus"], button[name="minus"]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input[type="number"], input[name="updates[]"]');
    if (!input) return;
    e.preventDefault();
    e.stopPropagation();
    var current = parseInt(input.value, 10) || 0;
    var min = parseInt(input.min, 10) || 0;
    var max = parseInt(input.max, 10);
    var next = btn.name === 'plus' ? current + 1 : current - 1;
    if (next < min) next = min;
    if (!isNaN(max) && next > max) next = max;
    if (next === current) return;
    input.value = next;
    var lineIndex = getLineIndex(input);
    if (next === 0) {
      // remove line
      changeLineQuantity(lineIndex, 0);
    } else {
      changeLineQuantity(lineIndex, next);
    }
  }

  var debouncedQtyChange = debounce(function (input) {
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) return;
    var lineIndex = getLineIndex(input);
    changeLineQuantity(lineIndex, qty);
  }, 600);

  function handleQtyInputChange(e) {
    var input = e.target;
    if (!input.matches('input[name="updates[]"], input[type="number"]')) return;
    if (!input.closest('cart-items, .cart-items, .maat-cart')) return;
    debouncedQtyChange(input);
  }

  function handleRemoveClick(e) {
    // O handler esta no <cart-remove-button> e tambem no document: o mesmo
    // clique chegava duas vezes e a 2a execucao removia a linha que subiu
    // para o lugar (reteste do R8). A 1a chama preventDefault; a 2a sai aqui.
    if (e.defaultPrevented) return;
    var btn = e.target.closest('cart-remove-button a, cart-remove-button button, [data-cart-remove], a[href*="cart/change"]');
    if (!btn) return;
    // O data-index do Dawn fica no <cart-remove-button> pai, nao no <a>, e o
    // href e ?id=..., nao ?line= (reteste R8: o Remover do /cart nao fazia nada).
    var host = btn.closest('cart-remove-button');
    var line = btn.dataset.index || btn.dataset.line || (host && (host.dataset.index || host.dataset.line));
    if (!line) {
      // tenta extrair da URL href ?line=X
      var href = btn.href || '';
      var m = /[?&]line=(\d+)/.exec(href);
      if (m) line = m[1];
    }
    // Sem linha identificada, deixa o link nativo (/cart/change) fazer o servico.
    if (!line) return;
    e.preventDefault();
    changeLineQuantity(parseInt(line, 10), 0);
  }

  function rewireQuantityInputs() {
    // No-op: nossos handlers globais de delegate ja funcionam mesmo apos re-render.
  }

  // ---------- shim custom elements ----------
  if (!customElements.get('quantity-input')) {
    customElements.define('quantity-input', class extends HTMLElement {
      connectedCallback() {
        if (this._maatBound) return;
        this._maatBound = true;
        this.addEventListener('click', handlePlusMinusClick);
        this.addEventListener('change', handleQtyInputChange);
      }
    });
  }
  if (!customElements.get('cart-items')) {
    customElements.define('cart-items', class extends HTMLElement {
      connectedCallback() {
        if (this._maatBound) return;
        this._maatBound = true;
        // delegate listeners no escopo do cart-items
        this.addEventListener('click', handlePlusMinusClick);
        this.addEventListener('click', handleRemoveClick);
        this.addEventListener('change', handleQtyInputChange);
      }
    });
  }
  if (!customElements.get('cart-remove-button')) {
    customElements.define('cart-remove-button', class extends HTMLElement {
      connectedCallback() {
        if (this._maatBound) return;
        this._maatBound = true;
        this.addEventListener('click', handleRemoveClick);
      }
    });
  }

  // Fallback global: caso markup nao use os custom elements,
  // delegate listener direto no document escopado a' pagina /cart
  if (window.location.pathname.indexOf('/cart') === 0) {
    document.addEventListener('click', handlePlusMinusClick);
    document.addEventListener('click', handleRemoveClick);
    document.addEventListener('change', handleQtyInputChange);
  }
})();
